import { connect } from 'react-redux';
import withGtmPageType from 'apps/gtm/utils/gtmPageType/withGtmPageType';
import FreeHtmlBanner from '../components/FreeHtmlBanner';

export default connect(
  state => {
    const { betaFeatures } = state.user;
    return ({
      forceVisibilityOnMobile: betaFeatures.includes('FHTML_BANNER_ON_MOBILE_FORCE'),
      checkVisibilityOnMobile: betaFeatures.includes('FHTML_BANNER_ON_MOBILE'),
    });
  },
)(withGtmPageType(FreeHtmlBanner));
